/* 1 Nov 2026 (Tony picked design C: "i think this would work very well on desktops and laptops"): quick filters in the collection
   toolbar on screens 1180px and wider - Portrait / Landscape / Square, colour dots, Size + Room menus. Each choice ticks the same box
   in the Filter and sort panel (#FacetFiltersFormMobile), so the panel's own logic runs (twin size spellings, languages, counts,
   results without a reload). Sort by sets the panel's sort. The toolbar is redrawn with the results, so it is rebuilt each time. */
(function () {
  function form() { return document.getElementById('FacetFiltersFormMobile'); }
  function group(name) {
    var f = form(), i = f && f.querySelector('input[name="' + name + '"]'), g = i ? i.closest('.lbf-group') : null;
    return g && g.style.display !== 'none' ? g : null;
  }
  // the search page hides boxes with no prints (laboo-search-page.js)
  function gone(l) { return l.style.display === 'none'; }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }
  function heading(g) { var h = g.querySelector('.lbf-head__label'); return h ? h.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function clean(t) { return t.replace(/\s+/g, ' ').trim(); }

  var open = null;
  function closeMenu() {
    if (!open) return;
    open.btn.setAttribute('aria-expanded', 'false');
    if (open.pop.parentNode) open.pop.parentNode.removeChild(open.pop);
    open = null;
  }
  // a quick button that ticks / unticks the panel box with this id
  function chip(input, cls) {
    var b = el('button', cls);
    b.type = 'button';
    b.setAttribute('aria-pressed', input.checked ? 'true' : 'false');
    b.addEventListener('click', function () {
      closeMenu();
      var i = document.getElementById(input.id) || input;
      i.click();
    });
    return b;
  }

  // button b opens a popover in wrap, filled by fill(pop)
  function popper(wrap, b, fill) {
    b.type = 'button';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      if (open && open.btn === b) { closeMenu(); return; }
      closeMenu();
      var pop = el('div', 'lb-qf__pop');
      fill(pop);
      pop.addEventListener('click', function (ev) { ev.stopPropagation(); });
      wrap.appendChild(pop);
      b.setAttribute('aria-expanded', 'true');
      open = { btn: b, pop: pop };
    });
    wrap.appendChild(b);
    return wrap;
  }

  function menu(g) {
    var t = heading(g);
    var b = el('button', 'lb-qf__menu' + (/\(\d+\)/.test(t) ? ' is-on' : ''), t);
    b.appendChild(el('span', 'lb-tbtn__caret'));
    return popper(el('span', 'lb-qf__wrap'), b, function (pop) {
      g.querySelectorAll('.lbf-panel .lbf-sub, .lbf-panel label.lbf-chip, .lbf-panel label.facet-checkbox').forEach(function (x) {
        if (x.classList.contains('lbf-sub')) { pop.appendChild(el('div', 'lb-qf__sub', clean(x.textContent))); return; }
        if (gone(x)) return;
        var i = x.querySelector('input.lbf-input') || x.querySelector('input[type="checkbox"]');
        if (!i) return;
        var c = chip(i, 'lb-qf__opt');
        c.textContent = clean(x.textContent);
        pop.appendChild(c);
      });
    });
  }

  // 1 Nov 2026 (Tony: "why are all these colors not on the color swatches"): the dots that do not fit go behind a "+N" button
  // that opens every colour with its name
  function moreColours(co) {
    var b = el('button', 'lb-qf__more');
    return popper(el('span', 'lb-qf__wrap lb-qf__wrap--more'), b, function (pop) {
      pop.classList.add('lb-qf__pop--colours');
      co.querySelectorAll('label.lbf-dot').forEach(function (l) {
        var i = l.querySelector('input'), c = l.querySelector('.lbf-dot__c');
        if (!i || gone(l)) return;
        var o = chip(i, 'lb-qf__opt lb-qf__opt--colour');
        var s = el('span', 'lb-qf__sw');
        if (c) s.setAttribute('style', c.getAttribute('style') || '');
        o.appendChild(s);
        o.appendChild(document.createTextNode(l.title));
        pop.appendChild(o);
      });
    });
  }

  function build() {
    var box = document.querySelector('[data-lb-qf]');
    if (!box || !form()) return;
    closeMenu();
    box.innerHTML = '';
    var sh = group('filter.p.tag');
    if (sh) {
      var row = el('div', 'lb-qf__shapes');
      sh.querySelectorAll('label.lbf-chip').forEach(function (l) {
        var i = l.querySelector('input');
        if (!i || gone(l)) return;
        var b = chip(i, 'lb-qf__chip lb-qf__chip--' + i.value);
        b.appendChild(el('i', 'lb-qf__shape'));
        b.appendChild(el('span', 'lb-qf__txt', clean(l.textContent)));
        b.title = clean(l.textContent);
        row.appendChild(b);
      });
      box.appendChild(row);
    }
    var co = group('filter.v.t.shopify.color-pattern');
    if (co) {
      var cw = el('div', 'lb-qf__colours');
      cw.appendChild(el('span', 'lb-qf__label', heading(co).replace(/\s*\(\d+\)$/, '')));
      co.querySelectorAll('label.lbf-dot').forEach(function (l) {
        var i = l.querySelector('input'), c = l.querySelector('.lbf-dot__c');
        if (!i || gone(l)) return;
        var b = chip(i, 'lb-qf__dot');
        b.title = l.title;
        b.setAttribute('aria-label', l.title);
        var s = el('span');
        if (c) s.setAttribute('style', c.getAttribute('style') || '');
        b.appendChild(s);
        cw.appendChild(b);
      });
      cw.appendChild(moreColours(co));
      box.appendChild(cw);
    }
    var menus = el('div', 'lb-qf__menus');
    // 1 Nov 2026 (Tony: "where is the style"): Style menu between Size and Room
    ['filter.v.option.size', 'filter.p.m.custom.filter_home_style', 'filter.p.m.custom.filter_rooms'].forEach(function (n) {
      var g = group(n);
      if (g) menus.appendChild(menu(g));
    });
    box.appendChild(menus);
    fit();
  }

  // all 16 dots show when there is room (big screens). Otherwise dots drop from the end behind "+N" (a ticked colour stays)
  // down to 8, then the "Colour" word goes, then dots down to 4; on a very tight bar the dots all go and the button reads
  // "Colour" + the number ticked; then the shape chips show just their icons and the dots get another go in the space that frees
  function fit(tight) {
    var box = document.querySelector('[data-lb-qf]'), right = document.querySelector('.lb-tbar__right');
    if (!box || !right || !box.lastElementChild || !box.offsetParent) return;
    var dots = [].slice.call(box.querySelectorAll('.lb-qf__dot')), lab = box.querySelector('.lb-qf__label');
    var more = box.querySelector('.lb-qf__more'), mw = more && more.parentNode;
    if (!more) return;
    var word = lab ? lab.textContent : '';
    var on = dots.filter(function (d) { return d.getAttribute('aria-pressed') === 'true'; }).length;
    var bar = right.parentNode, limit = bar.parentNode;
    box.classList.toggle('lb-qf--tight', !!tight);
    dots.forEach(function (d) { d.style.display = ''; });
    if (lab) lab.style.display = '';
    mw.style.display = 'none';
    more.className = 'lb-qf__more';
    // too wide = the quick filters run into Sort by, or the toolbar is pushed past its container
    var over = function () {
      var r = right.getBoundingClientRect();
      return box.lastElementChild.getBoundingClientRect().right > r.left - 12 ||
        r.right > Math.min(limit.getBoundingClientRect().right, document.documentElement.clientWidth) + 1;
    };
    if (!over()) return;
    mw.style.display = '';
    var vis = dots.slice();
    var label = function () {
      var h = dots.filter(function (d) { return d.style.display === 'none'; });
      more.textContent = '+' + h.length;
      more.classList.toggle('is-on', h.some(function (d) { return d.getAttribute('aria-pressed') === 'true'; }));
      more.setAttribute('aria-label', word + ' +' + h.length);
    };
    var drop = function (min) {
      for (var k = vis.length - 1; k >= 0 && over() && vis.length > min; k--) {
        if (vis[k].getAttribute('aria-pressed') === 'true' && min > 0) continue;
        vis[k].style.display = 'none';
        vis.splice(k, 1);
        label();
      }
    };
    label();
    drop(8);
    if (over() && lab) lab.style.display = 'none';
    drop(4);
    if (over()) {
      dots.forEach(function (d) { d.style.display = 'none'; });
      more.className = 'lb-qf__menu lb-qf__more' + (on ? ' is-on' : '');
      more.textContent = word + (on ? ' (' + on + ')' : '');
      more.appendChild(el('span', 'lb-tbtn__caret'));
    }
    if (over() && !tight) fit(true);
  }
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fit(); }, 120); });

  // Sort by (toolbar select) sets the panel's sort
  document.addEventListener('change', function (e) {
    if (!e.target.matches || !e.target.matches('[data-lb-qf-sort]')) return;
    var f = form(), r = f && f.querySelector('input[name="sort_by"][value="' + e.target.value + '"]');
    if (r && !r.checked) r.click();
  });
  document.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });
  document.addEventListener('facet:updated', build);

  function start() {
    build();
    var grid = document.getElementById('CollectionProductGrid');
    var t;
    if (grid) new MutationObserver(function () { clearTimeout(t); t = setTimeout(build, 30); }).observe(grid, { childList: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
